<template>
  <nav :class="{active}" id="sidebar">
    <template v-if="isLogged">

      <div class="icono">
        <a><img src="/img/icons/Bmail Resources/Icons/Application Icon/bmail-icon.svg" alt="IBERBOX"></a>
      </div>

      <div class="border-none">
        <router-link :class="comprobarReceived" to="/received" :aria-label="$t('bmail.received')" :title="$t('bmail.received')" :disabled="pMethod === 0" tag="button">
          <download-icon size="1.5x" class="custom-class"></download-icon>
          <span>{{ $t('bmail.received') }}</span>
          <p :style="recordsStyle">{{ numberRecords }}</p>
        </router-link>
      </div>

      <div class="border-none">
        <router-link :class="comprobarSent" to="/sent" :aria-label="$t('bmail.sent')" :title="$t('bmail.sent')" :disabled="pMethod === 0" tag="button">
          <send-icon size="1.5x" class="custom-class"></send-icon>
          <span>{{ $t('bmail.sent') }}</span>
        </router-link>
      </div>

      <div class="border-none">
        <router-link :class="comprobarInbox" to="/reg" :aria-label="$t('bmail.mailboxes')" :title="$t('bmail.mailboxes')" :disabled="pMethod === 0" tag="button">
          <inbox-icon size="1.5x" class="custom-class"></inbox-icon>
          <span>{{ $t('bmail.mailboxes') }}</span>
        </router-link>
      </div>

      <div class="border-none">
        <router-link :class="comprobarContacts" to="/contacts" :aria-label="$t('bmail.contacts')" :title="$t('bmail.contacts')" :disabled="pMethod === 0" tag="button">
          <user-icon size="1.5x" class="custom-class"></user-icon>
          <span>{{ $t('bmail.contacts') }}</span>
        </router-link>
      </div>

      <button v-if="!noAuth" @click="logout" class="action" id="logout" :aria-label="$t('sidebar.logout')" :title="$t('sidebar.logout')">
        <log-out-icon size="1.5x" class="custom-class"></log-out-icon>
        <span>{{ $t('sidebar.logout') }}</span>
      </button>

      <div class="space">
        <p class="used-space">{{ $t('sidebar.usedSpace') }}</p>
        <span>{{ spaceAvailableString }} ({{ availableSpace }})</span>
        <div class="spacebar">
          <div class="spacebar-value" :style="spaceBarStyles"></div>
        </div>
      </div>

      <div class="container-image">
        <router-link to="/profile" :aria-label="$t('sidebar.profile')" :title="$t('sidebar.profile')" style="width: 100%;">
          <p class="user-name">{{ this.userName }}</p>
        </router-link>
      </div>
      
    </template>
    <template v-else>
      <div class="icono">
        <a><img src="/img/icons/icono_blanco.png" alt="IBERBOX"></a>
      </div>

      <div class="border-none">
        <router-link :class="[isLogin ? 'action-activo' : 'action']" to="/login" :aria-label="$t('sidebar.login')" :title="$t('sidebar.login')">
          <img v-if="isLogin" src="/img/icons/Linear Icons/hover/login-icon-hover.svg">
          <img v-else src="/img/icons/Linear Icons/normal/login-icon.svg">
          <span>{{ $t('sidebar.login') }}</span>
        </router-link>
      </div> 
      
      <div class="border-none">
        <router-link v-if="signup" :class="[isSignup ? 'action-activo' : 'action']" to="/register" :aria-label="$t('sidebar.signup')" :title="$t('sidebar.signup')">
          <img v-if="isSignup" src="/img/icons/Linear Icons/hover/register-icon-hover.svg">
          <img v-else src="/img/icons/Linear Icons/normal/register-icon.svg">
          <span>{{ $t('sidebar.signup') }}</span>
        </router-link>
      </div>
    </template>
  </nav>
</template>

<script>
  
/*The MIT License (MIT)

Copyright (c) 2013-2017 Cole Bemis

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.*/ 

import { mapState, mapGetters } from 'vuex'
import * as auth from '@/utils/auth'
import { version, signup, disableExternal, noAuth } from '@/utils/constants'
import { files as ibbapi } from '@/api'
import { InboxIcon, UserIcon, LogOutIcon, SendIcon, DownloadIcon } from 'vue-feather-icons'
import filesize from 'filesize'

export default {
  name: 'sidebar',
  components: {
    InboxIcon,
    UserIcon,
    LogOutIcon,
    SendIcon,
    DownloadIcon
  },
  data: function () {
    return {
      isInboxClick: false,
      isTransferClick: false,
      isDealersClick: false,
      isConfigClick: false,
      isLogoutClick: false,
      isReseller: 0,
      pMethod: 0,
      isRotate: false,
      openSecrets: [],
      features: '',
      storageTotal: 0,
      storageUsed: 0,
      availableSpace: '0%',
      userName: '',
      numberRecords: 0
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    ...mapState([ 'user' ]),
    ...mapGetters([ 'isLogged' ]),
    active () {
      return this.$store.state.show === 'sidebar'
    },
    signup: () => signup,
    version: () => version,
    disableExternal: () => disableExternal,
    noAuth: () => noAuth,
    comprobarInbox() {
      if (this.pMethod === 0) {
        return 'action-disabled'
      } else if (this.$route.name === 'Reg') {
        return 'action-activo'
      } else {
        return 'action'
      }
    },
    comprobarContacts() {
      if (this.pMethod === 0) {
        return 'action-disabled'
      } else if (this.$route.name === 'Contacts') {
        return 'action-activo'
      } else {
        return 'action'
      }
    },
    comprobarSent() {
      if (this.pMethod === 0) {
        return 'action-disabled'
      } else if (this.$route.name === 'Sent') {
        return 'action-activo'
      } else {
        return 'action'
      }
    },
    comprobarReceived() {
      if (this.pMethod === 0) {
        return 'action-disabled'
      } else if (this.$route.name === 'Received') {
        return 'action-activo'
      } else {
        return 'action'
      }
    },
    recordsStyle() {
      if (this.numberRecords > 0 && this.$route.name !== 'Received') {
        return {backgroundColor: 'var(--blue)', color: 'white'}
      }
    },
    spaceAvailableString () {
      if (!this.storageTotal) {
        return this.$t('info.loading');
      }

      if (this.storageTotal > this.storageUsed)
      {
        return this.$t('info.availableSpaceInfo', { available: filesize(this.storageUsed), total: filesize(this.storageTotal)});
      }

      return this.$t('info.exhausted', { available: filesize(this.storageTotal), total: filesize(this.storageTotal)});
    },
    spaceBarStyles() {
      if (this.storageTotal > this.storageUsed) {
        return {width: this.availableSpace, backgroundColor: 'var(--blue)'};
      } else {
        return {width: this.availableSpace, backgroundColor: 'red'};
      }
    },
  },
  created () {
    var thisComponent = this;
    var JavaActionListenerClass = Module.ActionListener.extend("ActionListener", {
      onActionFinish: function(action)
      {
        if (action.type === Module.ActionType.UPLOAD.value || action.type === Module.ActionType.DELETE_NODE.value) {
          thisComponent.getStorage();
          return;
        }

        if (action.type == Module.ActionType.SET_RECORD_STATUS.value) {
          thisComponent.getRecords()
        }

        return
      }
    });

    var JavaEventListenerClass = Module.EventListener.extend("EventListener", {
      onEvent: function(event)
      {
        if ((event.type == Module.EventType.NEW_NODES.value && event.node.type == Module.NodeType.RECORD.value) || (event.type == Module.EventType.DELETED_NODE.value && event.node.type == Module.NodeType.RECORD.value))
        {
          thisComponent.getRecords()
          return;
        }

        if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.DELETED_NODE.value)
        {
          thisComponent.getStorage()
        }
        return
      }
    });

    this.interfaceObject = new JavaActionListenerClass();
    ibb.addActionListener(this.interfaceObject);
    ibb.addEventListener(new JavaEventListenerClass());
  },
  beforeDestroy () {
    ibb.removeActionListener(this.interfaceObject);
  },
  async mounted () {
    if (this.isLogged) {
      this.fetchData();
      this.getRecords();
      this.getStorage();
    }
  },
  methods: {
    async fetchData() {
      if (this.isLogged) {
        try {
          var invoicing = await ibbapi.getInvoicing()
          this.pMethod = invoicing.credit;
        } catch (e) {
          this.$showError(e)
        }

        try {
          var action = await ibbapi.getUserInfo();
          var userFirstname = action.userInfo.firstname;
          var userLastname = action.userInfo.lastname;
          this.userName = userFirstname.substr(0, 1) + userLastname.substr(0, 1);
        } catch (e) {
          this.$showError(e)
        }
      }
    },
    async getStorage () {
      try {
        var action = await ibbapi.getAccountInfo()
        this.storageUsed = action.accountInfo.ustorage;
        this.storageTotal = action.accountInfo.tstorage;

        if (this.storageTotal > this.storageUsed) {
          this.availableSpace = ((this.storageUsed/this.storageTotal)*100).toFixed(2) + '%'
        } else {
          this.availableSpace = 100 + '%'
        }
      } catch (e) {
        this.$showError(e)
      }
    },
    async getRecords() {
      this.numberRecords = 0;
      var action = await ibb.getRootNode(Module.NodeType.REGISTER_ROOT.value);
      if (action.error.type) {
        throw new Error("Error getting root node: " +  action.error.type)
      }
      this.records = []
      const {nodeList} = await ibb.getChildren(action.node.handle);
      for (let inbox of nodeList) {
        action = await ibb.getChildren(inbox.handle);
        for (let record of action.nodeList) {
          if (record.status === 0) {
            this.numberRecords = this.numberRecords + 1;
          }
        }
      }
    },
    help () {
      this.$store.commit('showHover', 'help')
    },
    logout: auth.logout
  }
}
</script>
